import React from "react"
import axios from "axios"
import clsx from "clsx"
import MySelectCreatableFormField from "@common-components/fields/MySelectCreatableFormField"
import MyInputFormField from "@common-components/fields/MyInputFormField"
import MyCheckboxFormField from "@common-components/fields/MyCheckboxFormField"
import MyDateMonthYearFormField from "@common-components/fields/MyDateMonthYearFormField"
import { CONST_MONTANT_INDEMNITE_PAR_KM, CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM } from "@common-constants/*"
import { toast } from "react-toastify"
import {
     CONST_API_UTILS_GET_GOOGLE_MAPS_ADDRESS_AUTOCOMPLETION_ENDPOINT,
     CONST_API_UTILS_GET_GOOGLE_MAPS_DISTANCE_BETWEEN_TWO_POINTS_IN_KM_ENDPOINT,
} from "../../../../../../../../../constants"

export const NdfMileageSection = ({ helpers, validationSchema, detailsIndemniteKm, setDetailsIndemniteKm }: any) => {
     if (helpers.values.categorie !== CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM) return null

     async function calculateDistance(departure?: string, arrival?: string) {
          if (departure && arrival) {
               return axios.post(CONST_API_UTILS_GET_GOOGLE_MAPS_DISTANCE_BETWEEN_TWO_POINTS_IN_KM_ENDPOINT, { departure, arrival }).then(({ data: { distance } }) => {
                    if (distance) setDetailsIndemniteKm((p: any) => ({ ...p, distanceEnKmEntreDepartEtDestination: distance }))
                    return distance || 0
               })
          }
          return 0
     }

     const syncKM = (dist: number, ar: boolean, nb: number) => {
          const dt = Number((dist * (ar ? nb * 2 : nb)).toFixed(2))
          setDetailsIndemniteKm((p: any) => ({
               ...p,
               distanceTotal: dt,
               montantTTC: Number((dt * CONST_MONTANT_INDEMNITE_PAR_KM).toFixed(2)),
          }))
          if (nb) helpers.setFieldValue("distanceTotale", dt)
     }

     const moisAnnee = helpers.values.moisAnneeKm
     const joursKm: number[] = (helpers.values.joursKm || []).map(Number)
     const maxTrajets = helpers.values.nbTrajets || 0
     const isAgendaReady = moisAnnee && helpers.values.adresseDepart && helpers.values.adresseArrive && maxTrajets > 0

     const renderAgenda = () => {
          if (!moisAnnee || !maxTrajets) return null
          const [year, month] = moisAnnee.split("-").map(Number)
          const daysInMonth = new Date(year, month, 0).getDate()
          const monthLabel = new Intl.DateTimeFormat("fr-FR", { month: "long", year: "numeric" }).format(new Date(year, month - 1))
          const isExactMatch = joursKm.length === maxTrajets

          return (
               <div className="row mb-6">
                    <div className="col-lg-4"></div>
                    <div className="col-lg-8">
                         <div
                              className={clsx(
                                   "p-5 border border-dashed rounded",
                                   helpers.errors.joursKm
                                        ? "border-danger bg-light-danger bg-opacity-25"
                                        : isExactMatch
                                        ? "border-success bg-light-success bg-opacity-25"
                                        : "border-primary bg-light-primary bg-opacity-25"
                              )}
                         >
                              <h6 className={clsx("mb-4 fw-boldest", helpers.errors.joursKm ? "text-danger" : isExactMatch ? "text-success" : "text-primary")}>
                                   Sélectionnez exactement {maxTrajets} jours en {monthLabel}
                              </h6>
                              <div className="d-flex flex-wrap gap-2">
                                   {Array.from({ length: daysInMonth }, (_, i) => {
                                        const d = i + 1
                                        const dt = new Date(year, month - 1, d)
                                        const isWE = dt.getDay() === 0 || dt.getDay() === 6
                                        const letter = new Intl.DateTimeFormat("fr-FR", { weekday: "narrow" }).format(dt)
                                        const isSel = joursKm.includes(d)
                                        return (
                                             <button
                                                  key={d}
                                                  type="button"
                                                  onClick={() => {
                                                       if (isSel) {
                                                            helpers.setFieldValue(
                                                                 "joursKm",
                                                                 joursKm.filter((x: number) => x !== d)
                                                            )
                                                       } else {
                                                            if (joursKm.length >= maxTrajets) {
                                                                 toast.warning(
                                                                      `Vous devez sélectionner exactement ${maxTrajets} jour(s). Désélectionnez-en un d'abord ou augmentez le nombre de trajets.`
                                                                 )
                                                                 return
                                                            }
                                                            helpers.setFieldValue(
                                                                 "joursKm",
                                                                 [...joursKm, d].sort((a, b) => a - b)
                                                            )
                                                       }
                                                  }}
                                                  className={clsx(
                                                       "btn btn-icon d-flex flex-column fw-bold",
                                                       isSel
                                                            ? "btn-primary shadow-sm"
                                                            : isWE
                                                            ? "bg-light text-muted opacity-75 border-gray-300"
                                                            : "bg-white text-gray-700 border-gray-300"
                                                  )}
                                                  style={{ width: "42px", height: "48px" }}
                                             >
                                                  <span className="fs-9 opacity-75">{letter}</span>
                                                  <span className="fs-6 mt-1">{d}</span>
                                             </button>
                                        )
                                   })}
                              </div>
                              <div className="mt-4 fs-7 d-flex align-items-center">
                                   <i className={clsx("fas fa-info-circle me-2", helpers.errors.joursKm ? "text-danger" : isExactMatch ? "text-success" : "text-muted")}></i>
                                   <span className="text-muted">Jours sélectionnés :</span>
                                   <strong className={clsx("ms-1", isExactMatch ? "text-success" : "text-danger")}>{joursKm.length}</strong>
                                   <span className="text-muted"> / {maxTrajets}</span>
                              </div>
                              {helpers.errors.joursKm && <div className="text-danger mt-2 fs-7 fw-bold">{helpers.errors.joursKm}</div>}
                         </div>
                    </div>
               </div>
          )
     }

     return (
          <>
               <MyDateMonthYearFormField
                    name="moisAnneeKm"
                    formikProps={helpers}
                    validationSchema={validationSchema}
                    label={<div className="required">Choisissez le mois</div>}
                    classNameLabel="col-lg-4"
                    classNameField="col-lg-8"
                    onChange={() => helpers.setFieldValue("joursKm", [])}
                    placeholder="MM/YYYY"
                    classNameLayout={"mb-2"}
               />
               {moisAnnee && (
                    <div className="">
                         <MySelectCreatableFormField
                              label={<div className="required">Départ</div>}
                              name="adresseDepart"
                              endpoint={CONST_API_UTILS_GET_GOOGLE_MAPS_ADDRESS_AUTOCOMPLETION_ENDPOINT}
                              classNameLabel="col-lg-4"
                              classNameField="col-lg-8"
                              formikProps={helpers}
                              method="GET"
                              isMulti={false}
                              validationSchema={validationSchema}
                              onChangeCallback={v =>
                                   calculateDistance(v as string, helpers.values.adresseArrive).then(d => syncKM(d, !!helpers.values.isAllerRetour, helpers.values.nbTrajets))
                              }
                              placeholder={"Saisissez l'adresse de départ"}
                              classNameLayout={"mb-2"}
                         />
                         <MySelectCreatableFormField
                              label={<div className="required">Arrivée</div>}
                              name="adresseArrive"
                              endpoint={CONST_API_UTILS_GET_GOOGLE_MAPS_ADDRESS_AUTOCOMPLETION_ENDPOINT}
                              classNameLabel="col-lg-4"
                              classNameField="col-lg-8"
                              isMulti={false}
                              method="GET"
                              formikProps={helpers}
                              validationSchema={validationSchema}
                              onChangeCallback={v =>
                                   calculateDistance(helpers.values.adresseDepart, v as string).then(d => syncKM(d, !!helpers.values.isAllerRetour, helpers.values.nbTrajets))
                              }
                              placeholder={"Saisissez l'adresse d'arrivée"}
                              classNameLayout={"mb-2"}
                         />
                         <div className="row mb-2">
                              <label className="col-lg-4 col-form-label fs-6 fw-bolder required">Trajets</label>
                              <div className="col-lg-8 d-flex gap-2">
                                   <MyInputFormField
                                        name="nbTrajets"
                                        type="number"
                                        placeholder={"Nombre de trajets"}
                                        formikProps={helpers}
                                        validationSchema={validationSchema}
                                        classNameLayout="mb-0"
                                        onChangeCallback={v => {
                                             syncKM(detailsIndemniteKm.distanceEnKmEntreDepartEtDestination, !!helpers.values.isAllerRetour, v)
                                             if (v < joursKm.length) helpers.setFieldValue("joursKm", [])
                                        }}
                                   />
                                   <div className="d-flex align-items-center">
                                        <MyCheckboxFormField
                                             name="isAllerRetour"
                                             formikProps={helpers}
                                             onChangeCallback={v => syncKM(detailsIndemniteKm.distanceEnKmEntreDepartEtDestination, v, helpers.values.nbTrajets)}
                                        />{" "}
                                        <span className="ms-2">Aller-retour</span>
                                   </div>
                              </div>
                         </div>
                         {isAgendaReady && (
                              <div>
                                   {renderAgenda()}
                                   <MyInputFormField
                                        formikProps={helpers}
                                        validationSchema={validationSchema}
                                        name={"distanceTotale"}
                                        type={"number"}
                                        placeholder={"Distance totale"}
                                        label={<div className={"required"}>Distance totale</div>}
                                        classNameLabel={"col-lg-4"}
                                        classNameField={"col-lg-8"}
                                        onChangeCallback={val => {
                                             setDetailsIndemniteKm((p: any) => ({
                                                  ...p,
                                                  distanceTotal: val,
                                                  montantTTC: Number((val * CONST_MONTANT_INDEMNITE_PAR_KM).toFixed(2)),
                                             }))
                                        }}
                                        classNameLayout={"mb-4"}
                                   />
                                   <div className={"p-4 border border-dashed text-gray-600 mb-6"}>
                                        <h4 className={"mb-4 text-gray-600"}>
                                             Détails de l'indemnité kilométrique
                                             <i className="fas fa-info-circle fs-3 float-end" />
                                        </h4>
                                        <div className="separator separator-dashed mb-6" />
                                        <p className="mb-0 fw-boldest fs-5">Montant TTC: {detailsIndemniteKm.montantTTC.toFixed(2)}€</p>
                                   </div>
                              </div>
                         )}
                    </div>
               )}
          </>
     )
}
